var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderstand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.88,
    height: 745.456,
    viewBox: "0 0 799.88 745.456",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(-745.929 -179.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(0 -51.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1863-1805",
    "data-name": "Path 1863",
    d: "M48.324,44.737c0,18.2-10.818,24.551-24.162,24.551S0,62.934,0,44.737,33.817,0,33.817,0,48.324,26.541,48.324,44.737Z",
    transform: "translate(1066.363 890.107) rotate(-3)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864-1806",
    "data-name": "Path 1864",
    d: "M9.711,63.113l.247-15.229,10.3-18.841L10,45.5l.111-6.848,7.1-13.631L10.138,36.835h0l.2-12.316,7.6-10.852L10.37,22.583,10.495,0,9.709,29.9l.065-1.233L2.046,16.834l7.6,14.2L8.93,44.785l-.021-.365L0,31.972,8.881,45.709l-.09,1.72-.016.026.007.141-1.827,34.9H9.4l.293-18.025,8.86-13.7Z",
    transform: "translate(1089.015 890.604) rotate(13)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(1297.029 231.285) rotate(25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1830-1807",
    "data-name": "Path 1830",
    d: "M141.344,231.136a7.549,7.549,0,0,1-1.676.432l-70.4,9.828a7.577,7.577,0,0,1-8.155-4.807L.507,78.9A7.609,7.609,0,0,1,5.952,68.744h0L72.16,53.969a6.045,6.045,0,0,0,1.47-.538l64.4-33.668a7.541,7.541,0,0,1,1.565-.609L210.46.261a7.594,7.594,0,0,1,9.063,4.623l52.84,137.5a7.572,7.572,0,0,1-1,7.275l-18.274,24.54a7.6,7.6,0,0,1-3.374,2.558L209.778,192.1a6.03,6.03,0,0,0-.83.395L142.4,230.635A7.612,7.612,0,0,1,141.344,231.136Z",
    transform: "translate(0.811 0.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831-1808",
    "data-name": "Path 1831",
    d: "M161.668,9.508l-9,2.4L128.82,18.269l-.042.01L96.127,35.351,84.01,41.687l-.006,0L65.806,51.2l-.5.112L46.4,55.532l-9.137,2.043L0,65.89,58.5,218.118l38.4-5.359,9.416-1.317,20.069-2.8.233-.03,64.489-36.961,39.237-15.079,17.914-24.056L197.337,0Z",
    transform: "translate(13.242 12.586)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 207.84,
    height: 9.261,
    transform: "translate(24.964 108.973) rotate(-21.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 207.84,
    height: 9.261,
    transform: "translate(36.038 137.79) rotate(-21.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 207.84,
    height: 9.261,
    transform: "translate(58.408 196) rotate(-21.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832-1809",
    "data-name": "Path 1832",
    d: "M9,0,67.081,151.133l-8.644,3.323L0,2.4Z",
    transform: "translate(165.91 22.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833-1810",
    "data-name": "Path 1833",
    d: "M57.2,0,45.276,33.184,41.141,44.7,31.494,71.554,29.427,77.3l-2.069,5.769L24.634,90.64,5.083,145.052,0,131.825,15.942,87.454l3.607-10.046.529-1.467,4.265-11.878,5.382-14.98,4.135-11.513L45.08,6.339l0,0Z",
    transform: "translate(52.167 47.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834-1811",
    "data-name": "Path 1834",
    d: "M127.211,152.838l-1.407.54L61.315,190.34l-.234.029L0,33.047l.5-.112,18.2-9.514,0,0,12.118-6.337L63.471.01,63.514,0Z",
    transform: "translate(78.549 30.854)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835-1812",
    "data-name": "Path 1835",
    d: "M142.445,232.705a8.393,8.393,0,0,1-1.855.478l-70.4,9.828a8.385,8.385,0,0,1-9.025-5.32L.56,80a8.421,8.421,0,0,1,6.026-11.24L72.794,53.989a5.265,5.265,0,0,0,1.271-.465l64.4-33.668a8.372,8.372,0,0,1,1.732-.674L211.062.289A8.4,8.4,0,0,1,221.091,5.4l52.84,137.5a8.38,8.38,0,0,1-1.106,8.051l-18.274,24.539a8.408,8.408,0,0,1-3.733,2.831L210.88,193.668a5.229,5.229,0,0,0-.718.341L143.614,232.15A8.414,8.414,0,0,1,142.445,232.705ZM6.563,72.151a5.177,5.177,0,0,0-2.973,6.688l60.6,157.689a5.154,5.154,0,0,0,5.548,3.27l70.4-9.828a5.2,5.2,0,0,0,1.859-.635l66.549-38.141a8.442,8.442,0,0,1,1.166-.554l39.937-15.348a5.171,5.171,0,0,0,2.3-1.74l18.274-24.539a5.15,5.15,0,0,0,.68-4.949l-52.84-137.5A5.166,5.166,0,0,0,211.9,3.424L141.029,22.317a5.334,5.334,0,0,0-1.064.414L75.568,56.4a8.563,8.563,0,0,1-2.067.756L7.293,71.931a5.152,5.152,0,0,0-.731.221Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836-1813",
    "data-name": "Path 1836",
    d: "M9.137,0,69.054,155.911l-9.415,1.316L0,2.043Z",
    transform: "translate(50.507 68.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    cx: 4.322,
    cy: 4.322,
    r: 4.322,
    transform: "translate(72.555 122.406)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 4.322,
    cy: 4.322,
    r: 4.322,
    transform: "translate(225.799 127.012)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837-1814",
    "data-name": "Path 1837",
    d: "M57.309,19.013c4.905,12.764-1,55.063-3.074,68.641a2.468,2.468,0,0,1-4,1.538C39.6,80.5,6.886,53.04,1.98,40.276A29.637,29.637,0,0,1,57.309,19.013Z",
    transform: "translate(174.562 34.259)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 16.053,
    cy: 16.053,
    r: 16.053,
    transform: "translate(188.154 47.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843-1815",
    "data-name": "Path 1843",
    d: "M815.13,754.1h-9.649V188.574a4.824,4.824,0,1,1,9.649,0Z",
    transform: "translate(266.208 221.979)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844-1816",
    "data-name": "Path 1844",
    d: "M930.357,716.394h-190.3a1.1,1.1,0,1,1,0-2.144h190.3a1.1,1.1,0,1,1,0,2.144Z",
    transform: "translate(236.736 260.218)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845-1817",
    "data-name": "Path 1845",
    d: "M886.695,256.138H746.306a4.83,4.83,0,0,1-4.824-4.824V210.574a4.83,4.83,0,0,1,4.824-4.824h140.4a4.835,4.835,0,0,1,2.351.612l36.306,20.261a4.824,4.824,0,0,1,.019,8.415l-36.316,20.478A4.838,4.838,0,0,1,886.695,256.138Z",
    transform: "translate(261.595 223.564)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846-1818",
    "data-name": "Path 1846",
    d: "M877.187,338.138H736.8a4.836,4.836,0,0,1-2.369-.622l-36.316-20.478a4.824,4.824,0,0,1,.019-8.415l36.306-20.261a4.834,4.834,0,0,1,2.351-.612h140.4a4.83,4.83,0,0,1,4.824,4.824v40.739a4.83,4.83,0,0,1-4.824,4.824Z",
    transform: "translate(258.292 229.475)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847-1819",
    "data-name": "Path 1847",
    d: "M877.687,418.638H737.3a4.836,4.836,0,0,1-2.369-.622l-36.316-20.478a4.824,4.824,0,0,1,.019-8.415l36.306-20.261a4.834,4.834,0,0,1,2.351-.612h140.4a4.83,4.83,0,0,1,4.824,4.824v40.739a4.83,4.83,0,0,1-4.824,4.824Z",
    transform: "translate(258.328 235.278)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(745.929 517.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1871-1820",
    "data-name": "Path 1871",
    d: "M377.224,594.882l-1.65,57.747-17.6,67.647s3.85,11.549,1.1,14.3-15.4,7.7-15.4,7.7l10.449-144.093Z",
    transform: "translate(-294.154 -320.443)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872-1821",
    "data-name": "Path 1872",
    d: "M336.774,779.59s-6.276,13.807,2.51,15.063,49.372,4.6,46.862-2.51-33.054-13.807-33.054-13.807Z",
    transform: "translate(-291.913 -365.739)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873-1822",
    "data-name": "Path 1873",
    d: "M306.431,526.908s6.6,35.748,11,41.8-2.2,50.047-2.2,50.047-9.9,63.247-5.5,73.146,3.3,6.6,2.75,12.1-1.65,9.9,0,14.849,1.65,4.4,2.2,7.15,0,17.6,0,17.6,23.649,8.25,27.5-3.85c0,0-5.5-7.7-3.85-13.749a73.245,73.245,0,0,0,2.75-18.7V695.749l25.3-94.6,6.05-34.1s-1.65-34.648-7.7-37.948S306.431,526.908,306.431,526.908Z",
    transform: "translate(-284.957 -303.616)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874-1823",
    "data-name": "Path 1874",
    d: "M318.64,810.507s-8.25,18.149,3.3,19.8,64.9,6.05,61.6-3.3-43.448-18.149-43.448-18.149Z",
    transform: "translate(-287.267 -373.276)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383",
    "data-name": "Ellipse 383",
    cx: 21.999,
    cy: 21.999,
    r: 21.999,
    transform: "translate(19.829 20.925)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875-1824",
    "data-name": "Path 1875",
    d: "M312.932,300.054l.41,28.094,26.971.091s-6.845-21.993-3.779-26.592S312.932,300.054,312.932,300.054Z",
    transform: "translate(-286.563 -247.409)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876-1825",
    "data-name": "Path 1876",
    d: "M348.463,352.737s-19.249-24.749-34.1-14.3-20.349,35.2-20.349,35.2l3.3,69.3s8.25,9.9,3.3,16.5-7.7,4.95-3.85,9.9,8.25,8.8,6.6,10.45,1.65,2.75,1.65,2.75l58.3,1.65s-1.65-2.2,3.3-8.8-1.1-15.4,0-18.7,2.2.55,2.75-7.15S348.463,352.737,348.463,352.737Z",
    transform: "translate(-281.892 -256.489)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877-1826",
    "data-name": "Path 1877",
    d: "M359.011,544.88s1.1,13.749,9.35,15.949c3.094.825,5.414-.748,7.106-3.036a13.506,13.506,0,0,0,.432-15.153l-2.038-3.26Z",
    transform: "translate(-297.94 -306.739)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878-1827",
    "data-name": "Path 1878",
    d: "M291.2,320.741s-.55,11,0,12.649,1.1,3.3,0,4.95-.55,7.15.55,7.7-2.2,5.5-1.1,8.8a23.858,23.858,0,0,0,2.75,5.5c.55,1.1,1.436,3.071,1.436,3.071S311,328.991,324.2,337.24s23.649,11,23.649,11S340.7,309.742,291.2,320.741Z",
    transform: "translate(-281.006 -252.267)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879-1828",
    "data-name": "Path 1879",
    d: "M317.277,355.3s-17.6,1.65-16.5,24.749-1.65,59.4-1.65,59.4,30.249,46.2,35.2,49.5,5.5,2.75,4.95,5.5-1.1,4.95,1.1,7.15a18.992,18.992,0,0,0,4.4,3.3s17.6-6.05,15.949-11.549-9.35-14.3-9.35-14.3-13.2-21.449-13.749-24.749-.55-2.75-2.2-4.4-6.05-8.25-6.05-11.549V427.9l4.611-55.842a16.189,16.189,0,0,0-4.293-12.537A14.007,14.007,0,0,0,317.277,355.3Z",
    transform: "translate(-283.154 -261.256)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881-1829",
    "data-name": "Path 1881",
    d: "M302.68,477.514l30.873,40.065S305.125,493.815,302.68,477.514Z",
    transform: "translate(-284.031 -291.464)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882-1830",
    "data-name": "Path 1882",
    d: "M98.617,359.249l-.292,37.838,17.931,26.9-14.671-30.157Z",
    transform: "translate(-50.335 -217.557)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412-1831",
    "data-name": "Path 1412",
    d: "M41.151,7.3c-1.844.11-3.644-.513-5.476-.756A13.859,13.859,0,0,0,20.862,16.879a7.929,7.929,0,0,1-.758,2.469c-1.008,1.646-3.3,1.96-5.2,1.582s-3.687-1.264-5.615-1.366a8.6,8.6,0,0,0-7.42,4.2,14.241,14.241,0,0,0-1.821,8.6l1.427-1.5a7.248,7.248,0,0,1,.646,3.939A4.571,4.571,0,0,0,6.453,33.7c1.258-.134.309,2.334,1.243,3.187a2.162,2.162,0,0,0,1.521.285c2.677-.026,4.842,2.022,6.951,3.67A29.539,29.539,0,0,0,28.645,46.53a16.413,16.413,0,0,0,9.1-.441A19.445,19.445,0,0,0,43.9,41.728c4.488-4.315,8.462-9.385,10.329-15.325a25.8,25.8,0,0,0,.124-14.959C53.595,8.9,51.328.209,48.008.007,43.838-.248,46.342,6.993,41.151,7.3Z",
    transform: "matrix(-0.777, 0.629, -0.629, -0.777, 72.602, 36.494)",
    fill: "#090814"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstand);
export default __webpack_public_path__ + "static/media/understand.99d1e0d5548c8d09b0fd07bb6c63b240.svg";
export { ForwardRef as ReactComponent };